export const GET_BETTING_HISTORY = 'GET_BETTING_HISTORY'

export const GET_BETTING_HISTORY_SUCCESS = 'GET_BETTING_HISTORY_SUCCESS'

export const GET_BETTING_HISTORY_FAILED = 'GET_BETTING_HISTORY_FAILED'

export const SET_BETTING_HISTORY = 'SET_BETTING_HISTORY'